import { render, staticRenderFns } from "./ErpIntegration.vue?vue&type=template&id=6cb24818&scoped=true&"
import script from "./ErpIntegration.vue?vue&type=script&lang=ts&"
export * from "./ErpIntegration.vue?vue&type=script&lang=ts&"
import style0 from "./ErpIntegration.vue?vue&type=style&index=0&id=6cb24818&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cb24818",
  null
  
)

export default component.exports